var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "#FFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0996 12C22.0996 15.3137 19.4133 18 16.0996 18C12.7859 18 10.0996 15.3137 10.0996 12C10.0996 8.68629 12.7859 6 16.0996 6C19.4133 6 22.0996 8.68629 22.0996 12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0996094 16C0.0996094 7.16344 7.26305 0 16.0996 0C24.9362 0 32.0996 7.16344 32.0996 16C32.0996 24.8366 24.9362 32 16.0996 32C7.26305 32 0.0996094 24.8366 0.0996094 16ZM16.0996 2C8.36762 2 2.09961 8.26801 2.09961 16C2.09961 19.3069 3.24612 22.3459 5.16333 24.7414C6.58547 22.4505 9.70889 20 16.0996 20C22.4904 20 25.6138 22.4505 27.0359 24.7414C28.9531 22.3459 30.0996 19.3069 30.0996 16C30.0996 8.26801 23.8316 2 16.0996 2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.da0eece80d64a080d0a8c65106aefab1.svg";
export { ForwardRef as ReactComponent };